import { Button } from '@/common/components/Button/Button';
import { Stack } from '@/common/components/Stack/Stack';
import { notify } from '@/common/utils/toast/toast';

export const PlaygroundToasts = () => {
  return (
    <Stack horizontal gap="md" wrap>
      <Button
        onPress={() => {
          notify({
            type: 'success',
            message: 'Success toast',
          });
        }}
        variant="secondary"
        size="sm"
      >
        Success
      </Button>
      <Button
        onPress={() => {
          notify({
            type: 'warning',
            message: 'Warning toast',
          });
        }}
        variant="secondary"
        size="sm"
      >
        Warning
      </Button>
      <Button
        onPress={() => {
          notify({
            type: 'error',
            message: 'Error toast',
          });
        }}
        variant="secondary"
        size="sm"
      >
        Error
      </Button>
      <Button
        onPress={() => {
          notify({
            type: 'success',
            message: 'Closable toast',
            closable: true,
          });
        }}
        variant="secondary"
        size="sm"
      >
        Closable
      </Button>
      <Button
        onPress={() => {
          notify({
            type: 'success',
            message:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          });
        }}
        variant="secondary"
        size="sm"
      >
        Long message
      </Button>
    </Stack>
  );
};
